import React from 'react'
import { SurfacePalette, type } from '../../../tokens'
import { sectionNumberFor, SectionKey } from '../../sections'
import { PresentPage } from '../PresentPage'

interface Props {
  palette: SurfacePalette
  packetID: number
  sectionKey: Extract<SectionKey, 'audience-framework' | 'creative'>
  title: string
  body: string
}

export const PresentPlaceholder = ({ palette, packetID, sectionKey, title, body }: Props) => (
  <PresentPage
    palette={palette}
    number={sectionNumberFor(sectionKey)}
    title={title}
    commentAnchor={{ type: 'section', id: `${packetID}:${sectionKey}`, label: title }}
  >
    <p
      style={{
        margin: 0,
        maxWidth: 640,
        fontFamily: type.family.sans,
        fontSize: type.size.bodyLg,
        lineHeight: 1.5,
        color: palette.textMuted,
      }}
    >
      {body}
    </p>
  </PresentPage>
)
